var _excluded = ["size", "color", "onClick", "cursor", "display", "data-test-name", "aria-label"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import * as React from "react"; // DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details

import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import { colorNessieResponsivePropType, oneOfNessieResponsivePropType } from "../../propTypes";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
var SkillsAddIcon = function SkillsAddIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "m" : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "shale" : _ref$color,
    onClick = _ref.onClick,
    cursor = _ref.cursor,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? "inline-block" : _ref$display,
    dataTestName = _ref["data-test-name"],
    ariaLabel = _ref["aria-label"],
    props = _objectWithoutProperties(_ref, _excluded);
  var sizeInPixels = SIZES[size];
  var ButtonOrSpan = onClick ? UnstyledButton : "span";
  return _jsx(ButtonOrSpan, {
    "aria-label": ariaLabel,
    "data-test-name": dataTestName,
    onClick: onClick,
    sx: {
      fontSize: sizeInPixels,
      display: display,
      lineHeight: 0,
      color: color,
      cursor: cursor,
      position: "relative"
    },
    children: _jsxs("svg", _objectSpread(_objectSpread({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {}, {
      children: [_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.858 9.32c-.222-.045-.49-.045-.712-.045-3.385 0-6.146 2.717-6.057 6.101 0 .98.223 1.915.668 2.762h-.044l-.25.191c-1.156.886-1.656 1.268-2.155 1.768a.506.506 0 01-.357.134.506.506 0 01-.356-.134c-.4-.4-.801-.712-1.559-1.291a66.134 66.134 0 01-1.571-1.203l-.344-.267C4.94 15.644 2 13.328 2 9.988 2 6.737 4.494 5 6.81 5c1.603 0 3.028.713 4.141 2.049C12.065 5.713 13.534 5 15.093 5c2.182 0 4.454 1.514 4.765 4.32zm-.2 1.18c.056.011.111.022.156.022A4.894 4.894 0 0124 15.376a4.885 4.885 0 01-4.899 4.9c-2.004 0-3.696-1.159-4.453-2.85v-.045c-.022-.067-.045-.123-.067-.179a2.99 2.99 0 01-.067-.178c0-.022-.011-.033-.022-.044-.011-.011-.022-.023-.022-.045-.023-.067-.045-.144-.067-.222a5.432 5.432 0 00-.067-.223v-.045a1.583 1.583 0 01-.089-.445v-.09c-.045-.177-.045-.355-.045-.534a4.885 4.885 0 014.9-4.898h.4c.045 0 .1.01.156.022zm.022 5.456h1.648c.312 0 .579-.268.579-.624a.59.59 0 00-.58-.579h-1.602V13.15a.58.58 0 00-.49-.58h-.09a.59.59 0 00-.578.58V14.798h-1.603a.59.59 0 00-.58.579c0 .222.09.4.223.49.09.044.178.088.312.088h1.603v1.604a.59.59 0 00.58.579.59.59 0 00.578-.58v-1.602z"
      }), _jsx("mask", {
        maskUnits: "userSpaceOnUse",
        x: 2,
        y: 5,
        width: 22,
        height: 16,
        children: _jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.858 9.32c-.222-.045-.49-.045-.712-.045-3.385 0-6.146 2.717-6.057 6.101 0 .98.223 1.915.668 2.762h-.044l-.25.191c-1.156.886-1.656 1.268-2.155 1.768a.506.506 0 01-.357.134.506.506 0 01-.356-.134c-.4-.4-.801-.712-1.559-1.291a66.134 66.134 0 01-1.571-1.203l-.344-.267C4.94 15.644 2 13.328 2 9.988 2 6.737 4.494 5 6.81 5c1.603 0 3.028.713 4.141 2.049C12.065 5.713 13.534 5 15.093 5c2.182 0 4.454 1.514 4.765 4.32zm-.2 1.18c.056.011.111.022.156.022A4.894 4.894 0 0124 15.376a4.885 4.885 0 01-4.899 4.9c-2.004 0-3.696-1.159-4.453-2.85v-.045c-.022-.067-.045-.123-.067-.179a2.99 2.99 0 01-.067-.178c0-.022-.011-.033-.022-.044-.011-.011-.022-.023-.022-.045-.023-.067-.045-.144-.067-.222a5.432 5.432 0 00-.067-.223v-.045a1.583 1.583 0 01-.089-.445v-.09c-.045-.177-.045-.355-.045-.534a4.885 4.885 0 014.9-4.898h.4c.045 0 .1.01.156.022zm.022 5.456h1.648c.312 0 .579-.268.579-.624a.59.59 0 00-.58-.579h-1.602V13.15a.58.58 0 00-.49-.58h-.09a.59.59 0 00-.578.58V14.798h-1.603a.59.59 0 00-.58.579c0 .222.09.4.223.49.09.044.178.088.312.088h1.603v1.604a.59.59 0 00.58.579.59.59 0 00.578-.58v-1.602z"
        })
      })]
    }))
  });
};
var SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px"
};
SkillsAddIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"])
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  SkillsAddIcon = nessiePropCheckerWrapper(SkillsAddIcon);
}
export default SkillsAddIcon;